/** @jsx jsx */
import React from "react";
import { jsx } from "theme-ui";
import HeroSection from "../components/sections/heroSection";
import CustomHtml from "../components/sections/customHTML";
import SideBySideGroupSection from "../components/sections/sideBySideGroupSection";
import GridSection from "../components/sections/gridSection";
import GallerySection from "../components/sections/gallerySection";
import RichTextSection from "../components/sections/richTextSection";
import FormSection from "../components/sections/formSection";
import Testimonial from "../components/sections/testimonialSection";
import FaqCollection from "../components/sections/faqCollection";
import IndexedContentSection from "../components/sections/IndexedContentSection";
import ContributorCardsSection from "../components/sections/ContributorCardsSection";

const GenerateSection = ({ section }) => {
  const { __typename } = section;
  switch (__typename) {
    case "ContentfulCustomHtml":
      return <CustomHtml sectionContent={section} />;
    case "ContentfulHeroSection":
      return <HeroSection sectionContent={section} />;
    case "ContentfulSideBySideGroupSection":
      return <SideBySideGroupSection sectionContent={section} />;
    case "ContentfulGridSection":
      return <GridSection sectionContent={section} />;
    case "ContentfulGallerySection":
      return <GallerySection sectionContent={section} />;
    case "ContentfulRichTextSection":
      return <RichTextSection sectionContent={section} />;
    case "ContentfulFormSection":
      return <FormSection sectionContent={section} />;
    case "ContentfulTestimonialSection":
      return <Testimonial sectionContent={section}/>;
    case "ContentfulFaqCollection":
      return <FaqCollection sectionContent={section}/>;
    case "ContentfulIndexedContentSection":
      return <IndexedContentSection sectionContent={section}/>;
    case "ContentfulContributorCardsSection":
        return <ContributorCardsSection sectionContent={section}/>;
    default:
      return <> </>;
  }
};

export default GenerateSection;
